<template>
  <div class="pdf-wrapper" v-if="Object.keys(leipzigKuchastudiesEntry).length > 0">
    <a :href="leipzigKuchastudiesEntry.url">
      <v-card-title class="pb-1 mb-2" style="background-color:transparent; white-space: normal; display: inline-block;" v-html="getBibTitle(leipzigKuchastudiesEntry)"></v-card-title>
    </a>

    <div v-if="loading" class="d-flex align-center justify-center" style="height:100%; min-height: 300px;">
      <v-progress-circular indeterminate color="primary" size="48" />
    </div>

    <v-card v-else class="mb-1 pb-2" outlined color="transparent" style="border-color: rgba(0, 0, 0, 0.38)!important;">
      <div v-if="isMobile()">
        <v-btn :href="pdfURL" target="_blank" block color="primary" outlined class="my-4">
          PDF in neuem Tab öffnen
        </v-btn>
      </div>
      <div style="height: 100%;" v-else>
        <object
          :key="pdfURL"
          type="application/pdf"
          :data="pdfURL"
          width="100%"
          style="height: 100%;"
        >
          <p>PDF cannot be displayed here in this browser. <a :href="pdfURL" target="_blank">Please open it in a different tab</a>.</p>
        </object>
      </div>
    </v-card>
  </div>
</template>
<script>
import "pdfjs-dist/web/pdf_viewer.css";


import * as pdfjsLib from "pdfjs-dist";

import {getBibTitle} from  "@/utils/helpers"
pdfjsLib.GlobalWorkerOptions.workerSrc = "https://kucha.saw-leipzig.de/kis/scripts/pdf/pdf.worker.min.js";
import { isMobile } from "../utils/helpers";
export default {
  name: 'kuchaStudiesPDFVIew',
  components: {
  },
  props: {
    leipzigKuchastudiesEntry: {
      type: Object,
      default: function(){
        return {}
      }
    },
    pdfViewerID: {
      type: String,
      default: function(){
        return "pdfViewer"
      }
    }
  },
  data () {
    return {
      leipzigKuchastudieTabs: null,
      pdfViewer: null,
      bibEntry: null,
      pdfURL: "",
      loading: false,
    }
  },
  computed: {
    loadedPDFs: {
      get: function(){
        return this.$store.state.loadedPDFs
      },
      set: function(newValue){
        this.$store.commit("setLoadedPDFs", newValue)
      }
    }
  },
  methods: {
    isMobile(){
      return isMobile()
    },

    async getPdf(bibEntry) {
      this.bibEntry = bibEntry;
      console.log("checking  forPDF", this.loadedPDFs);
      if (this.loadedPDFs[bibEntry.url] !== undefined){
        this.loading = false
        console.log("PDF already loaded", this.loadedPDFs[bibEntry.url]);
        this.afterCreated(this.loadedPDFs[bibEntry.url].pdf, bibEntry, this.loadedPDFs[bibEntry.url].arrayBuffer);
      } else {
        this.loading = true;
        try {
          this.$log.debug("getPDF", this.getURL());
          const response = await fetch(this.getURL());
          const arrayBuffer = await response.arrayBuffer();
          this.$log.debug("arrayBuffer", arrayBuffer);

          const loadingTask = pdfjsLib.getDocument({ data: arrayBuffer });
          const pdf = await loadingTask.promise;
          this.loading = false
          console.log("PDF loaded, saving", pdf);
          this.loadedPDFs[bibEntry.url] = {pdf: pdf, arrayBuffer: arrayBuffer}
          this.afterCreated(pdf, bibEntry, arrayBuffer);
        } catch (err) {
          console.error(err);
          this.loading = false;
        }
      }

    },
    getURL(){
      if (this.leipzigKuchastudiesEntry){
        const url = (window.location.origin.includes("test") ? process.env.VUE_APP_USERREG : process.env.VUE_APP_USERREG) + '/resource?pdf=' + this.leipzigKuchastudiesEntry.annotatedBibliographyID
        console.log("getURL: ", url)
        return url
      }

    },
    afterCreated(pdf, bibEntry, arrayBuffer){
      const pageLabel = this.getFirstPage(bibEntry);
      pdf.getPageLabels().then((des) => {

        // Erstelle Blob-URL aus dem geladenen PDF
        const blob = new Blob([arrayBuffer], { type: 'application/pdf' });
        const blobURL = URL.createObjectURL(blob);

        // Füge Seitenzahl als Fragment an
        if (this.pdfURL.startsWith("blob:")) {
          URL.revokeObjectURL(this.pdfURL);
        }
        this.pdfURL = blobURL;
        if (pageLabel !== "") {
          const destination = des.indexOf(pageLabel) + 1;
          this.pdfURL += "#page=" + destination
        } else {
          this.pdfURL += "#page=Cover"
        }
       this.loading = false;
      });
    },
    getFirstPage(bibEntry){
      const bibTitle = bibEntry.quotedPages ? bibEntry.quotedPages : "";
      const ppIndex = bibTitle.indexOf("pp.");
      const pIndex = bibTitle.indexOf("p.");

      if (ppIndex !== -1) {
        // eslint-disable-next-line no-useless-escape
        const breakpoint = /[\-–]/
        const pageNumber = bibTitle.slice(ppIndex + 4).split(breakpoint)[0].trim();
        return pageNumber;
      } else if (pIndex !== -1) {
        const pageNumber = bibTitle.slice(pIndex + 3).split(",")[0].trim();
        return pageNumber;
      } else {
        return "";
      }
    },
    getBibTitle(bibEntry){
      if (this.bibEntry !== null){
        return getBibTitle(bibEntry)
      }
      return ""
    },
    initPDF(){
      this.loading = true
      if (Object.keys(this.leipzigKuchastudiesEntry).length >0) {
        this.getPdf(this.leipzigKuchastudiesEntry);
      }
    }
  },
  watch: {
    leipzigKuchastudiesEntry: function(newVal, oldVal) {
      this.initPDF()
    }
  },
  mounted:function () {
    this.$log.debug("leipzig kucha studies mounted", this.leipzigKuchastudiesEntry, location)
    this.initPDF()
  },
  beforeUpdate:function () {
  }
}
</script>

<style lang="css" scoped >
.pdf-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.v-card {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

object {
  flex-grow: 1;
}

</style>
